import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty, slice } from 'lodash';
import MediaQuery from 'react-responsive';

import { NB_AFFICHAGE_GRILLE } from '../../../services/directory/constants';

import ButtonComponent from '../../../components/button/ButtonComponent';
import { withLoadingCondition } from '../../loading/withLoadingCondition';
import PartnerBlockComponent from '../../../components/partner/PartnerBlockComponent';

import './GridDirectoryComponent.scss';

class GridDirectoryComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            borneMax: NB_AFFICHAGE_GRILLE
        };
        this.observer = null;
        this.seeMoreNode = null;
    }

    onClickVoirPlus(e) {
        e.preventDefault();
        this.previousBorneMax = this.state.borneMax;
        this.setState({
            borneMax: this.state.borneMax + NB_AFFICHAGE_GRILLE
        });
    }

    // Chargement automatique au scroll : le conteneur du bouton "voir plus"
    // sert de sentinelle ; le bouton est conservé (accessibilité : lecteurs
    // d'écran, navigation clavier, navigateurs sans IntersectionObserver).
    setSeeMoreNode = node => {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        this.seeMoreNode = node;
        if (node && typeof IntersectionObserver !== 'undefined') {
            this.observer = new IntersectionObserver(this.onSeeMoreVisible, {
                rootMargin: '200px 0px'
            });
            this.observer.observe(node);
        }
    };

    onSeeMoreVisible = entries => {
        if (entries.some(entry => entry.isIntersecting)) {
            this.setState(state => ({
                borneMax: state.borneMax + NB_AFFICHAGE_GRILLE
            }));
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.borneMax !== this.state.borneMax) {
            // Seul le clic explicite déplace le focus sur le premier nouveau
            // bloc ; un déplacement lors du chargement au scroll volerait le
            // focus en pleine navigation.
            if (this.previousBorneMax != null) {
                const list = document.getElementById('annuaire-liste');
                if (list) {
                    const articles = list.querySelectorAll('article.bloc-partenaire');
                    const firstNew = articles[this.previousBorneMax];
                    if (firstNew) {
                        firstNew.setAttribute('tabindex', '-1');
                        firstNew.focus();
                    }
                }
                this.previousBorneMax = null;
            }
            // Ré-observe la sentinelle : l'observer ne notifie que les
            // changements d'état, or si le bouton reste dans la zone après le
            // rendu des nouveaux blocs il faut enchaîner un chargement.
            if (this.observer && this.seeMoreNode) {
                this.observer.unobserve(this.seeMoreNode);
                this.observer.observe(this.seeMoreNode);
            }
        }
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    renderNoPartner = () => {
        const { partners, NO_PARTNER } = this.props;

        if (isEmpty(partners)) {
            return <div role="status">{NO_PARTNER}</div>;
        }
    };

    renderSeeMoreButton = () => {
        const { partners, SEE_MORE_OFFERS } = this.props;

        if (partners && this.state.borneMax && partners.length > this.state.borneMax) {
            return (
                <div className="conteneur-voir-plus" ref={this.setSeeMoreNode}>
                    <ButtonComponent
                        color="second"
                        text={SEE_MORE_OFFERS}
                        cssClass="bt-plus-offres"
                        onClick={this.onClickVoirPlus.bind(this)}
                    />
                </div>
            );
        }
    };

    renderGrid = () => {
        const { partners, isCodePromo, isOffline, isEbon, showType } = this.props;

        return (
            <div>
                <MediaQuery query="(min-width: 1024px)">
                    {matches => (
                        <div
                            id="annuaire-liste"
                            className={`${
                                matches ? 'grid-4-small-2' : 'grid-3-small-2'
                            } has-gutter`}>
                            {slice(partners, 0, this.state.borneMax).map(
                                (item, i) =>
                                    item && (
                                        <PartnerBlockComponent
                                            key={i}
                                            partner={item}
                                            isCodePromo={isCodePromo}
                                            // Grille mixte (annuaire par catégorie tous types
                                            // d'offres) : le type est porté par chaque bloc et
                                            // prime sur celui de la page.
                                            isOffline={
                                                item.blockIsOffline != null
                                                    ? item.blockIsOffline
                                                    : isOffline
                                            }
                                            isEbon={
                                                item.blockIsEbon != null ? item.blockIsEbon : isEbon
                                            }
                                            isBilletterie={!!item.blockIsBilletterie}
                                            isCouponsOnly={!!item.blockIsCouponsOnly}
                                            hideType={!showType}
                                        />
                                    )
                            )}
                        </div>
                    )}
                </MediaQuery>
                {this.renderSeeMoreButton()}
            </div>
        );
    };

    renderPage = () => (
        <div>
            {this.renderGrid()}
            {this.renderNoPartner()}
        </div>
    );

    render() {
        return withLoadingCondition(this.props.fetching, this.renderPage);
    }
}

GridDirectoryComponent.propTypes = {
    isCodePromo: PropTypes.bool,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool,
    partners: PropTypes.array.isRequired,
    fetching: PropTypes.bool.isRequired,
    // Affiche le type d'offre sur chaque bloc (annuaire mixte tous types
    // d'offres) ; masqué par défaut sur les annuaires mono-type.
    showType: PropTypes.bool
};

const mapStatetoProps = state => ({
    SEE_MORE_OFFERS: state.i18n.common.SEE_MORE_OFFERS,
    NO_PARTNER: state.i18n.page.DIRECTORY.NO_PARTNER
});

export default connect(mapStatetoProps)(GridDirectoryComponent);



// WEBPACK FOOTER //
// ./src/components/pages/directory/GridDirectoryComponent.js